import React from 'react'
import styles from './Modals.module.scss'

// Modals
import TimeoutModal from './TimeoutModal/TimeoutModal'

const ClientModals = props => (
  <div className={styles.modal__group}>
    <TimeoutModal />
  </div>
)

export default ClientModals



// WEBPACK FOOTER //
// ./src/components/Client/Modals/Modals.jsx